import config from '../services/config';

export const URL = config.URL_API;
export const SOCKETURL = process.env.REACT_APP_SOCKET_URL || 'ws://localhost:8000';

// export const URL = "http://devneobo.kanieba.com:8881";
// export const SOCKETURL = "wss://devneobo.kanieba.com:8881";
